import React, { useEffect } from "react";

import "../../css/Home.css";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../../config";

function ServiceNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const serviceMapping = {
    1: "/service/ai-enabled-event-details",
    2: "/service/invite",
    3: "/service/hire-a-priest",
    4: "/service/book-catering",
    5: "/service/rental-services-for-events",
  };

  const checkActivePath = (key) => {
    return location?.pathname?.includes(serviceMapping[key]);
  };

  return (
    <div className="th-service__navigation">
      <div className="th-service__navigation__container">
        <div
          className={`th-service__nav__button ${
            checkActivePath(1) ? "th-service__nav__button--active" : ""
          }`}
          onClick={() => navigate(serviceMapping[1])}
        >
          <div className="th-service__nav__icon__container">
            <div className="th-service__nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M10.6362 2V3.97451"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.7915 2V3.97451"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.6146 8.34894V5.73228C13.6198 3.92836 12.5249 2.94629 10.7573 2.94629H5.67698C3.91458 2.94629 2.81445 3.92836 2.81445 5.73228V11.1622C2.81445 12.9947 3.91458 13.9987 5.67698 13.9987H8.35595"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.38281 6.60059H11.0469"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.9905 13.3188L10.926 13.1443C10.6828 12.4863 10.1648 11.9675 9.50772 11.724L9.3335 11.6594L9.50772 11.5949C10.1648 11.3513 10.6828 10.8325 10.926 10.1745L10.9905 10L11.0549 10.1745C11.2981 10.8325 11.8161 11.3513 12.4732 11.5949L12.6475 11.6594L12.4732 11.724C11.8161 11.9675 11.2981 12.4863 11.0549 13.1443L10.9905 13.3188Z"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.3805 14.111C14.2709 13.7506 13.9893 13.4684 13.6294 13.3587C13.9893 13.249 14.2709 12.9669 14.3805 12.6064C14.4901 12.9669 14.7717 13.249 15.1317 13.3587C14.7717 13.4684 14.4901 13.7506 14.3805 14.111Z"
                  stroke={checkActivePath(1) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            className={`${
              checkActivePath(1)
                ? "th-service__nav__text__active"
                : "th-service__nav__text"
            }`}
          >
            Checklist / To-do list
          </div>
        </div>
        <div
          className={`th-service__nav__button ${
            checkActivePath(2) ? "th-service__nav__button--active" : ""
          }`}
          onClick={() => navigate(serviceMapping[2])}
        >
          <div className="th-service__nav__icon__container">
            <div className="th-service__nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M13.2216 8.93538L4.21245 13.6764C3.3958 14.1063 2.43645 13.4009 2.65115 12.5287L3.75969 8.0269L2.65115 3.5239C2.43645 2.65166 3.3958 1.94687 4.21245 2.37674L13.2216 7.11778C13.9675 7.5108 13.9675 8.54236 13.2216 8.93538Z"
                  stroke={checkActivePath(2) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.34087 8.01172L3.78516 8.03988"
                  stroke={checkActivePath(2) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            className={`${
              checkActivePath(2)
                ? "th-service__nav__text__active"
                : "th-service__nav__text"
            }`}
          >
            Send Invitation
          </div>
        </div>
        {config.isIndia && (
          <div
            className={`th-service__nav__button ${
              checkActivePath(3) ? "th-service__nav__button--active" : ""
            }`}
            onClick={() => navigate(serviceMapping[3])}
          >
            <div className="th-service__nav__icon__container">
              <div className="th-service__nav__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M9.42769 27.3344C7.40233 27.3344 6.17844 26.0202 6.0918 24.1898C6.0918 20.464 10.1245 19.1788 16.2005 19.1354C22.2876 19.1932 26.3311 20.4784 26.3093 24.1898C26.2119 26.0202 24.9952 27.3344 22.9735 27.3344H9.42769Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M16.2111 14.8837C19.0324 14.8837 21.3196 12.5966 21.3196 9.7752C21.3196 6.95383 19.0324 4.66666 16.2111 4.66666C13.3898 4.66666 11.1025 6.95383 11.1025 9.7752C11.1025 12.5966 13.3898 14.8837 16.2111 14.8837Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                </svg>
              </div>
            </div>
            <div
              className={`${
                checkActivePath(3)
                  ? "th-service__nav__text__active"
                  : "th-service__nav__text"
              }`}
            >
              Book a Priest
            </div>
          </div>
        )}
        <div
          className={`th-service__nav__button ${
            checkActivePath(4) ? "th-service__nav__button--active" : ""
          }`}
          onClick={() => navigate(serviceMapping[4])}
        >
          <div className="th-service__nav__icon__container">
            <div className="th-service__nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M13.4214 11.6143L13.2418 12.2033C13.0426 12.8571 12.4394 13.304 11.7564 13.304H4.2463C3.56327 13.304 2.96002 12.8571 2.76089 12.2033L2.58121 11.6143M2.00098 11.6143H14.001"
                  stroke={checkActivePath(4) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.77829 3.47045C8.77829 3.04234 8.43129 2.69531 8.00316 2.69531C7.57503 2.69531 7.22803 3.04234 7.22803 3.47045C7.22803 3.89855 7.57523 4.24535 8.00329 4.24535C8.43143 4.24535 8.77829 3.89855 8.77829 3.47045Z"
                  stroke={checkActivePath(4) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.67086 9.84812C2.51843 6.80012 4.94891 4.24512 8.00083 4.24512C11.0527 4.24512 13.4832 6.80012 13.3314 9.84812"
                  stroke={checkActivePath(4) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            className={`${
              checkActivePath(4)
                ? "th-service__nav__text__active"
                : "th-service__nav__text"
            }`}
          >
            Order Catering
          </div>
        </div>
        <div
          className={`th-service__nav__button ${
            checkActivePath(5) ? "th-service__nav__button--active" : ""
          }`}
          onClick={() => navigate(serviceMapping[5])}
        >
          <div className="th-service__nav__icon__container">
            <div className="th-service__nav__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M6.31824 6.18619C6.31824 7.29213 5.38159 8.18859 4.31586 8.18859C3.25013 8.18859 2.31348 7.32519 2.31348 6.18619C2.31348 5.61084 2.6644 4.06446 2.89986 3.34771C3.1217 2.67052 3.75348 2.21387 4.46634 2.21387H12.1509C12.8611 2.21387 13.4903 2.66663 13.7154 3.33992C13.9554 4.05797 14.3135 5.60889 14.3135 6.18619C14.3135 7.26293 13.3768 8.18859 12.3111 8.18859C11.2453 8.18859 10.3081 7.29213 10.3081 6.18619"
                  stroke={checkActivePath(5) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.12988 9.73438V10.8883C3.12988 12.5852 4.18653 13.7838 5.88469 13.7838H10.7424C12.4413 13.7838 13.4979 12.5852 13.4979 10.8883V9.73438"
                  stroke={checkActivePath(5) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.31152 5.5625V6.18845C6.31152 7.2944 7.20792 8.1908 8.31392 8.1908C9.41986 8.1908 10.3163 7.2944 10.3163 6.18845V5.5625"
                  stroke={checkActivePath(5) ? "#383838" : "#646464"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            className={`${
              checkActivePath(5)
                ? "th-service__nav__text__active"
                : "th-service__nav__text"
            }`}
          >
            Rent from tent houses
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceNavigation;
